module.exports = __webpack_public_path__ + "static/media/hands_18.0f91d2b4.svg";